module.exports = __webpack_public_path__ + "img/infoSign.83595f84.svg";